import { render, staticRenderFns } from "./NotSeatedApplicants.vue?vue&type=template&id=2662074c"
import script from "./NotSeatedApplicants.vue?vue&type=script&lang=js"
export * from "./NotSeatedApplicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports